import { createFileRoute } from '@tanstack/react-router';
import { KanbanPage, lerBusca } from '@/components/orcamentos-lista';

export const Route = createFileRoute('/_app/vender/orcamentos/kanban')({
  validateSearch: (bruto: Record<string, unknown>) => lerBusca(bruto),
  component: KanbanRota,
});

function KanbanRota() {
  return <KanbanPage busca={Route.useSearch()} />;
}
